import { get, ref, remove, update } from "firebase/database";
import { db } from "../firebaseConfig";

export const deletePartnerInvestment = async (investmentId: string) => {
	if (!investmentId) throw new Error("investmentId is required");

	const investmentRef = ref(db, `partnerInvestments/${investmentId}`);
	const snapshot = await get(investmentRef);
	const investment = snapshot.val();
	if (!investment) {
		throw new Error("Investment not found");
	}

	// Clear linked items' investment references
	const updates: Record<string, any> = {};
	const itemLinks = investment.itemLinks || [];
	itemLinks.forEach((link: any) => {
		if (link && link.itemKey) {
			updates[`items/${link.itemKey}/investmentId`] = null;
			updates[`items/${link.itemKey}/investmentCode`] = null;
		}
	});

	// Apply item updates and then remove the investment node
	if (Object.keys(updates).length) {
		await update(ref(db), updates);
	}

	await remove(investmentRef);
	return true;
};
